import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import VideoPreviewModal from '../my_inbox/VideoPreviewModal/VideoPreviewModal';
import { getPitchVideo } from '../views_shared_copies/api/pitchVideos';

// Media-side playback of a pitch's recorded video on the pitch card. The video lives in V2
// (attached via the wizard's bridge API); most pitches have none, so this renders nothing
// until the lookup returns one.
function PitchCardVideo({ pitchId }) {
  const [video, setVideo] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [posterFailed, setPosterFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await getPitchVideo(pitchId);
      if (cancelled || error || !data?.data) { return; }
      setVideo({
        posterUrl: data.data.attributes.poster_url,
        videoUrl: data.data.attributes.video_url,
      });
    })();
    return () => { cancelled = true; };
  }, [pitchId]);

  if (!video) { return null; }

  return (
    <div className="mt-2" data-testid="pitch-card-video">
      <div className="position-relative" style={{ width: 220 }}>
        <button
          type="button"
          className="border-0 p-0 bg-transparent w-100"
          onClick={() => setShowPreview(true)}
          aria-label="Play the video pitch"
        >
          {video.posterUrl && !posterFailed ? (
            <img
              src={video.posterUrl}
              alt="Video pitch preview"
              className="w-100 rounded"
              onError={() => setPosterFailed(true)}
            />
          ) : (
            <div className="w-100 rounded bg-dark" style={{ aspectRatio: '16/9' }} />
          )}
          <span
            className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-circle bg-white"
            style={{ width: 44, height: 44, opacity: 0.9 }}
          >
            <i className="fa-solid fa-play" aria-hidden="true" />
          </span>
        </button>
      </div>
      <VideoPreviewModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        src={video.videoUrl}
        title="Video Pitch"
        modalClassName="pitch-video-modal"
      />
    </div>
  );
}

PitchCardVideo.propTypes = {
  pitchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PitchCardVideo;
